import {
  GOOD_PERFORMANCE_INDICATORS,
  MEASUREMENT_CALCULATIONS,
  MEASUREMENT_LEVELS,
  QUALITY_DOMAINS,
  TIME_BOUNDS,
  TIME_FRAMES
} from '../../shared/constants/checkpoint-performance-report-metric-enums';
import { isTotalCountMeasurement } from '../services/performanceItemService';

const PerformanceItemMapper = {
  performanceItemToGraphData: pi => {
    const measurement = getPerformanceItemMeasurement(pi);

    return {
      Id: pi.Id,
      MeasurementName: pi.MeasurementName,
      MeasurementUnit: pi.MeasurementUnit,
      Numerator: pi.Numerator,
      Denominator: pi.Denominator,
      QualityDomain: mapPerformanceItemData(QUALITY_DOMAINS, pi.QualityDomain).Value,
      DomainDefinition: mapPerformanceItemData(QUALITY_DOMAINS, pi.QualityDomain).Description,
      QualityObjective: pi.QualityObjective,
      BusinessObjective: pi.BusinessObjective,
      MeasurementLevel: mapPerformanceItemData(MEASUREMENT_LEVELS, pi.MeasurementLevel).Value,
      MeasurementDescription: pi.MeasurementDescription,
      MeasurementCalculation: mapPerformanceItemData(
        MEASUREMENT_CALCULATIONS,
        pi.MeasurementCalculation
      ).Value,
      MeasurementCalculationId: pi.MeasurementCalculation,
      TimeBound: mapPerformanceItemData(TIME_BOUNDS, pi.TimeBounds).Value,
      TimeFrame: mapPerformanceItemData(TIME_FRAMES, pi.TimeFrame).Value,
      GoodPerformanceIndicator: mapPerformanceItemData(
        GOOD_PERFORMANCE_INDICATORS,
        pi.GoodPerformanceIndicator
      ).Value,
      BlindSpots: pi.LimitationsOrBlindSpots,
      MeasurementUse: pi.MeasurementUse,
      CaptureFrequency: mapPerformanceItemData(TIME_FRAMES, pi.CaptureFrequency).Value,
      ReportFrequency: mapPerformanceItemData(TIME_FRAMES, pi.ReportFrequency).Value,
      Measurement: measurement,
      IsDiscontinued: pi.IsDiscontinued,
      ExpirationDate: pi.ExpirationDate
    };
  }
};

const getPerformanceItemMeasurement = pi => {
  return isTotalCountMeasurement(pi.MeasurementCalculation)
    ? pi.MeasurementUnit
    : `${pi.Numerator} / ${pi.Denominator}`;
};

const mapPerformanceItemData = (data, id) => {
  const key = Object.keys(data).find(x => data[x].Id == id);
  return data[key] ? data[key] : 'N/A';
};

export default PerformanceItemMapper;
